import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Resolve,
  RouterStateSnapshot
} from '@angular/router';
import { SessionService } from '../services/session.service';
import { Observable, of } from 'rxjs/index';
import { RouterService } from '../services/router.service';
import { LoginService } from '../services/login.service';
import { LogService } from '../services/log.service';
import { ForgotPasswordService } from '../services/forgot-password.service';
import { Challenge } from '../types/challenge';
import { ForgotUsernameService } from '../services/forgot-username.service';

@Injectable({
  providedIn: 'root'
})
export class ForgotUsernameGuard implements CanActivate {
  constructor(
    private workflow: ForgotUsernameService,
    private router: RouterService,
    private log: LogService
  ) {}

  canActivate() {
    if (!this.workflow.isInProgress()) {
      this.log.trace('forgot username not in progress, denying access');
      this.router.gotoLogin();
      return false;
    }

    return true;
  }
}
